import gql from 'graphql-tag'

export const updateMyUserBillingAddressMutation = gql`
mutation updateMyUserBillingAddress($id: ID!, $addressInput: UserBillingAddressInput!) {
    updateMyUserBillingAddress(address_id: $id, address: $addressInput) {
        id
    }
}
`
